import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const CustomerMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [id, setId] = useState("");
  const [customerC, setCustomerC] = useState("");
  const [customerCError, setCustomerCError] = useState(false);
  const [customerN, setCustomerN] = useState("");
  const [customerNError, setCustomerNError] = useState(false);
  const [contactP, setContactP] = useState("");
  const [contactPError, setContactPError] = useState(false);
  const [department, setDepartment] = useState("");
  const [departmentError, setDepartmentError] = useState(false);
  const [contactN, setContactN] = useState("");
  const [contactNError, setContactNError] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [emailIdError, setEmailIdError] = useState(false);
  const [fullAd, setFullAd] = useState("");
  const [fullAdError, setFullAdError] = useState(false);

  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [cNameTwo, setCNameTwo] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    //   fetchCompaniesName();
    //   fetchCompaniesNameTwo();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/SelectAllCustomerDataMaster"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  // const fetchCompaniesName = async () => {
  //   try {
  //     const response = await axios.post(
  //        BASE_URL+"/api/master/getPlantCode"
  //     );
  //     if (response.data.success) {
  //       setCName(response.data.response);
  //     }
  //   } catch (error) {
  //     toast.error("Error fetching company data:", error);
  //   }
  // };

  // const fetchCompaniesNameTwo = async () => {
  //   try {
  //     const response = await axios.post(
  //        BASE_URL+"/api/master/getAllCatagorycodeAssetMaster"
  //     );
  //     if (response.data.success) {
  //       setCNameTwo(response.data.response);
  //     }
  //   } catch (error) {
  //     toast.error("Error fetching company data:", error);
  //   }
  // };

  const formvalidation = () => {
    let isValid = true;
    if (customerC === "") {
      setCustomerCError(true);
      isValid = false;
    }else {
      setCustomerCError(false);
    }
    if (customerN === "") {
      setCustomerNError(true);
      isValid = false;
    }else {
      setCustomerNError(false);
    }
    if (contactP === "") {
      setContactPError(true);
      isValid = false;
    }else {
      setContactPError(false);
    }
    if (department === "") {
      setDepartmentError(true);
      isValid = false;
    }else {
      setDepartmentError(false);
    }
    if (contactN === "") {
      setContactNError(true);
      isValid = false;
    }else {
      setContactNError(false);
    }
    if (emailId === "") {
      setEmailIdError(true);
      isValid = false;
    }else {
      setEmailIdError(false);
    }
    if (fullAd === "") {
      setFullAdError(true);
      isValid = false;
    }else {
      setFullAdError(false);
    }
    if (status === "") {
      setStatusError(true);
      isValid = false;
    }else {
      setStatusError(false);
    }

    return isValid;
  }

  const onSubmit = async () => {
    if (formvalidation()) {
      
   
    const data = {
      CustomerCode: customerC,
      CustomerName: customerN,
      ContactPerson: contactP,
      Department: department,
      ContactNo: contactN,
      EmailId: emailId,
      CusAddress: fullAd,
      AStatus: status,
      User: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertCustomer",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  }else {
    toast.error("Please fill all the fields");
  }
  };

  const onUpdate = async () => {
    const data = {
      Id: id,
      CustomerCode: customerC,
      CustomerName: customerN,
      ContactPerson: contactP,
      Department: department,
      ContactNo: contactN,
      EmailId: emailId,
      CusAddress: fullAd,
      AStatus: status,
      User: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updateCustomerDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setId("");
    setCustomerC("");
    setCustomerN("");
    setContactP("");
    setDepartment("");
    setContactN("");
    setEmailId("");
    setFullAd("");
    setStatus("");
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    stopErrorHelper();
  };

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    const result = companies.filter((company) =>
      searchWords.every((word) =>
        Object.entries(company).some(([key, value]) => {
          // Skip null or undefined values
          if (value == null) return false;
  
          // Convert to string and compare
          return value.toString().toLowerCase().includes(word);
        })
      )
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const stopErrorHelper = () => {
    setCustomerCError(false);
    setCustomerNError(false);
    setContactPError(false);
    setDepartmentError(false);
    setContactNError(false);
    setEmailIdError(false);
    setFullAdError(false);
    setStatusError(false);
  }

  const handleRowSelect = (company) => {
    setId(company.Id);
    setCustomerC(company.CustomerCode);
    setCustomerN(company.CustomerName);
    setContactP(company.ContactPerson);
    setDepartment(company.Department);
    setContactN(company.ContactNo);
    setEmailId(company.EmailId);
    setFullAd(company.CusAddress);
    setStatus(company.AStatus);
    setFormMode("edit");
    stopErrorHelper();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Supplier Master</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
            Supplier Master (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="supplier Code (*)"
                  name="supplier Code"
                  fullWidth
                  size="small"
                  value={customerC}
                  error={customerCError}
                  helperText={customerCError ? "supplier Code is required" : ""}
                  onChange={(e) => setCustomerC(e.target.value)}
                  disabled={formMode === "initial"} // Disable field if in view mode
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Supplier Name (*)"
                  name="Customer Name"
                  fullWidth
                  size="small"
                  value={customerN}
                  error={customerNError}
                  helperText={customerNError ? "Customer Name is required" : ""}
                  onChange={(e) => setCustomerN(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Contact Person (*)"
                  name="Contact Person"
                  fullWidth
                  size="small"
                  value={contactP}
                  error={contactPError}
                  helperText={contactPError ? "Contact Person is required" : ""}
                  onChange={(e) => setContactP(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Department  (*)"
                  name="Department "
                  fullWidth
                  size="small"
                  value={department}
                  error={departmentError}
                  helperText={departmentError ? "Department is required" : ""}
                  onChange={(e) => setDepartment(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Contact No "
                  name="Contact No"
                  fullWidth
                  size="small"
                  value={contactN}
                  error={contactNError}
                  helperText={contactNError ? "Contact No is required" : ""}
                  onChange={(e) => setContactN(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Email Id "
                  name="Email Id"
                  fullWidth
                  size="small"
                  value={emailId}
                  error={emailIdError}
                  helperText={emailIdError ? "Email Id is required" : ""}
                  onChange={(e) => setEmailId(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  multiline
                  minRows={3}
                  maxRows={6}
                  label="Full Address (*)"
                  name="Full Address"
                  fullWidth
                  size="small"
                  value={fullAd}
                  error={fullAdError}
                  helperText={fullAdError ? "Full Address is required" : ""}
                  onChange={(e) => setFullAd(e.target.value)}
                  disabled={formMode === "initial"}
                  sx={{
                    // You can adjust the width here if needed
                    width: "100%", // Full width of its container
                    "& .MuiInputBase-root": {
                      // Ensure that the text area takes up all available space
                      width: "100%",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Status(*)"
                  name="Status"
                  fullWidth
                  size="small"
                  value={status}
                  error={statusError}
                  helperText={statusError ? "Status is required" : ""}
                  onChange={(e) => setStatus(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Deactive">Deactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Supplier Code</th>
                    <th>Supplier Name</th>
                    <th>Contact Person</th>
                    <th>Department</th>
                    <th>Constact No</th>
                    <th>Email Id</th>
                    <th>Supplier Address</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.Id}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-label="Customer Code">{company.CustomerCode}</td>
                      <td data-label="Customer Name">{company.CustomerName}</td>
                      <td data-label="Contact Person">
                        {company.ContactPerson}
                      </td>
                      <td data-label="Department">{company.Department}</td>
                      <td data-label="Constact No">{company.ContactNo}</td>
                      <td data-label="Email Id">{company.EmailId}</td>
                      <td data-label="Customer Address">
                        {company.CusAddress}
                      </td>
                      <td data-label="Status">{company.AStatus}</td>

                      <td data-label="Created By">{company.CreatedBy}</td>
                      <td data-label="Created Date">
                        {new Date(company.CreatedDate).toLocaleString()}
                      </td>
                      <td data-label="Modified By">{company.ModifiedBy}</td>
                      <td data-label="Modified Date">
                        {company.ModifiedDate
                          ? new Date(company.ModifiedDate).toLocaleString()
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default CustomerMaster;
